import { FC, memo } from 'react'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

export const withAutoFocus = function <T extends object>(
  Component: FC<T & { autoFocus?: boolean }>,
): FC<T> {
  return memo(props => {
    const { isPhone } = useMediaQueries()
    return <Component autoFocus={!isPhone} {...(props as T)} />
  })
}
